"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  PageNotFound: true
};
exports.default = exports.PageNotFound = void 0;
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useWindowSize = _interopRequireDefault(require("../utils/useWindowSize"));
var _useResizeObserver = _interopRequireDefault(require("../utils/useResizeObserver"));
var _Illustration = _interopRequireDefault(require("./_Illustration"));
var _PageNotFound = require("./PageNotFound.types");
Object.keys(_PageNotFound).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PageNotFound[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PageNotFound[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// ⚠️ THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
var DialogPageNotFound = function DialogPageNotFound(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_2331_5787",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "12",
    y: "12",
    width: "148",
    height: "148"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "86.115",
    cy: "86.115",
    r: "73.885",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_2331_5787)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M200.927 7.134H-21.564A11.037 11.037 0 0 0-32.612 18.17v130.782A11.044 11.044 0 0 0-21.564 160h222.491a11.048 11.048 0 0 0 11.047-11.047V18.171a11.024 11.024 0 0 0-3.236-7.808 11.04 11.04 0 0 0-7.811-3.23Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M-25.06 83.568H78.835a2.384 2.384 0 0 1 1.556.547c.438.363.733.87.832 1.43l12.635 65.527a2.406 2.406 0 0 1-.483 2.048 2.39 2.39 0 0 1-1.906.876H-11.231a2.442 2.442 0 0 1-1.535-.547 2.46 2.46 0 0 1-.853-1.394l-13.829-65.527a2.406 2.406 0 0 1 .465-2.073 2.39 2.39 0 0 1 1.924-.887Zm10.27 17.496 7.93 43.573a2.382 2.382 0 0 0 2.388 2.001H67.06a2.39 2.39 0 0 0 2.388-2.9l-2.866-15.111h11.202a2.465 2.465 0 0 0 1.879-.908 2.467 2.467 0 0 0 .51-2.028l-6.139-32.704a2.482 2.482 0 0 0-.838-1.432 2.466 2.466 0 0 0-1.55-.581H41.075a2.453 2.453 0 0 0-1.873.903 2.473 2.473 0 0 0-.516 2.02l.836 4.459-51.864-.18a2.381 2.381 0 0 0-1.93.841 2.399 2.399 0 0 0-.518 2.047Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M125.35 153.996H16.844l3.034 4.326A3.942 3.942 0 0 0 23.102 160h-34.13a2.386 2.386 0 0 1-1.69-.702 2.402 2.402 0 0 1-.699-1.695v-1.09a2.4 2.4 0 0 1 .7-1.695 2.382 2.382 0 0 1 1.689-.702H125.35v-.12Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m19.878 158.322-3.034-4.326H125.35v3.883c0 .562-.222 1.102-.619 1.5a2.112 2.112 0 0 1-1.495.621H23.102a3.934 3.934 0 0 1-3.224-1.678ZM58.82 98.427l-19.357-.071-.836-4.458a2.478 2.478 0 0 1 .515-2.02 2.46 2.46 0 0 1 1.873-.904h30.572c.568.009 1.115.214 1.55.58.436.367.731.873.838 1.433l6.139 32.703a2.481 2.481 0 0 1-.51 2.029 2.451 2.451 0 0 1-1.879.908H66.524l-5.363-28.21a2.399 2.399 0 0 0-.81-1.422 2.383 2.383 0 0 0-1.53-.568Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.302 115.696a.98.98 0 0 1-.23-1.111.98.98 0 0 1 .23-.327.996.996 0 0 1 1.106-.227c.123.053.234.13.327.227l2.388 2.397 2.389-2.397a1.014 1.014 0 0 1 1.689.731 1.02 1.02 0 0 1-.256.707l-2.389 2.397 2.389 2.397a1.012 1.012 0 0 1 .34.731 1.022 1.022 0 0 1-.64.977 1.016 1.016 0 0 1-1.133-.27l-2.389-2.397-2.388 2.397a.994.994 0 0 1-1.106.227.996.996 0 0 1-.327-.227.98.98 0 0 1-.23-1.111.98.98 0 0 1 .23-.327l2.388-2.397-2.388-2.397Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m-12.378 98.176 51.865.18 19.358.071a2.384 2.384 0 0 1 1.56.553c.438.364.731.874.828 1.437l5.362 28.21 2.866 15.111a2.404 2.404 0 0 1-1.341 2.683 2.377 2.377 0 0 1-1.047.217H-4.39a2.383 2.383 0 0 1-1.563-.557 2.397 2.397 0 0 1-.825-1.444l-7.99-43.573a2.406 2.406 0 0 1 .5-2.023 2.39 2.39 0 0 1 1.89-.865Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m162.03 55.369-53.211-18.296a4.314 4.314 0 0 0-5.484 2.696L76.813 117.47a4.338 4.338 0 0 0 2.686 5.505l53.211 18.295a4.314 4.314 0 0 0 5.484-2.696l26.521-77.702a4.337 4.337 0 0 0-2.685-5.504Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M130.116 56.702a9.531 9.531 0 0 0-5.532-.475 9.555 9.555 0 0 0-4.863 2.69 9.626 9.626 0 0 0-1.939 10.486 9.588 9.588 0 0 0 3.576 4.263 9.54 9.54 0 0 0 10.626-.135 9.596 9.596 0 0 0 3.468-4.352l-8.888-3.557 3.552-8.92Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m132.959 55.385-3.544 8.912 8.881 3.557a9.622 9.622 0 0 0-2.207-10.43 9.551 9.551 0 0 0-3.13-2.04Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color20)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m140.329 87.265-37.08-12.75a2.352 2.352 0 0 0-2.99 1.47 2.365 2.365 0 0 0 1.464 3.002l37.08 12.749a2.352 2.352 0 0 0 2.99-1.47 2.365 2.365 0 0 0-1.464-3.001ZM137.122 94.826l-37.079-12.749a2.352 2.352 0 0 0-2.99 1.47 2.365 2.365 0 0 0 1.464 3.002l37.079 12.748a2.353 2.353 0 0 0 2.991-1.47 2.365 2.365 0 0 0-1.465-3ZM116.757 96.295l-19.754-6.791a2.352 2.352 0 0 0-2.99 1.47 2.365 2.365 0 0 0 1.464 3l19.754 6.792a2.352 2.352 0 0 0 2.99-1.47 2.365 2.365 0 0 0-1.464-3Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.344 23.44a3.567 3.567 0 1 1 0-7.134 3.567 3.567 0 0 1 0 7.133Zm0-.952a2.616 2.616 0 1 1 0-5.231 2.616 2.616 0 0 1 0 5.231Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M162.162 30.234c.224-.954-2.368-2.368-6.03-3.408.654-3.748.483-6.688-.473-6.91-.955-.221-2.398 2.364-3.471 6.033-3.773-.615-6.728-.432-6.939.528-.212.96 2.368 2.37 6.031 3.408-.644 3.75-.484 6.688.47 6.91.953.22 2.4-2.364 3.473-6.033 3.773.615 6.726.431 6.939-.528Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "m102.691 22.285-67.157 4.861a5.873 5.873 0 0 0-5.434 6.282l6.856 94.704a5.874 5.874 0 0 0 6.282 5.434l67.157-4.861a5.874 5.874 0 0 0 5.433-6.282l-6.855-94.704a5.874 5.874 0 0 0-6.282-5.434Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.534 27.146a5.866 5.866 0 0 0-3.487 1.476 2 2 0 0 0 2.45.793c.365-.148.761-.243 1.181-.274l4.478-.324a2 2 0 0 0 1.85-2.14l-6.472.47Zm15.914-1.152a2 2 0 0 0 2.139 1.85l8.954-.648a2 2 0 0 0 1.85-2.139l-12.943.937Zm22.385-1.62a2 2 0 0 0 2.14 1.85l8.954-.648a2 2 0 0 0 1.85-2.14l-12.944.938Zm22.386-1.62a2 2 0 0 0 2.139 1.85l4.477-.325c.42-.03.826.007 1.208.102a2 2 0 0 0 2.311-1.138 5.916 5.916 0 0 0-1.832-.804 5.865 5.865 0 0 0-1.831-.154l-6.472.468Zm11.278 1.478a2 2 0 0 0-.793 2.45c.148.365.243.76.274 1.18l.274 3.789a2 2 0 0 0 2.139 1.85l-.418-5.782a5.86 5.86 0 0 0-1.476-3.487Zm2.428 16.644a2 2 0 0 0-1.85 2.14l.548 7.576a2 2 0 0 0 2.139 1.85l-.837-11.566Zm1.371 18.941a2 2 0 0 0-1.85 2.14l.548 7.576a2 2 0 0 0 2.139 1.85l-.837-11.566Zm1.371 18.941a2 2 0 0 0-1.85 2.14l.548 7.576a2 2 0 0 0 2.14 1.85l-.838-11.566Zm1.372 18.94a2 2 0 0 0-1.851 2.14l.549 7.576a2 2 0 0 0 2.139 1.851l-.837-11.566Zm1.371 18.942a2 2 0 0 0-1.851 2.139l.275 3.788c.03.42-.007.826-.102 1.208a2.002 2.002 0 0 0 1.138 2.311 5.87 5.87 0 0 0 .958-3.663l-.418-5.783Zm-1.529 10.589a2 2 0 0 0-2.45-.793 3.899 3.899 0 0 1-1.181.274l-4.477.324a2 2 0 0 0-1.85 2.139l6.472-.468a5.86 5.86 0 0 0 3.486-1.476Zm-19.4 2.628a2 2 0 0 0-2.14-1.851l-8.954.648a2 2 0 0 0-1.85 2.14l12.944-.937Zm-22.386 1.62a2 2 0 0 0-2.139-1.85l-8.954.648a2 2 0 0 0-1.85 2.139l12.943-.937Zm-22.385 1.621a2 2 0 0 0-2.14-1.851l-4.477.324a3.86 3.86 0 0 1-1.208-.101 2.002 2.002 0 0 0-2.31 1.138 5.838 5.838 0 0 0 1.831.804c.584.144 1.2.2 1.832.154l6.472-.468Zm-11.278-1.479a2 2 0 0 0 .793-2.45 3.87 3.87 0 0 1-.274-1.181l-.275-3.788a2 2 0 0 0-2.139-1.851l.419 5.783a5.862 5.862 0 0 0 1.476 3.487Zm-2.429-16.645a2 2 0 0 0 1.85-2.139l-.548-7.576a2 2 0 0 0-2.139-1.85l.837 11.565Zm-1.37-18.94a2 2 0 0 0 1.85-2.14l-.549-7.576a2 2 0 0 0-2.139-1.85l.837 11.566ZM33.26 77.093a2 2 0 0 0 1.85-2.14l-.548-7.576a2 2 0 0 0-2.14-1.85l.838 11.566ZM31.89 58.152a2 2 0 0 0 1.85-2.14l-.548-7.576a2 2 0 0 0-2.14-1.85l.838 11.566Zm-1.371-18.94a2 2 0 0 0 1.85-2.14l-.274-3.788a3.87 3.87 0 0 1 .101-1.209 2 2 0 0 0-1.138-2.31 5.874 5.874 0 0 0-.804 1.832 5.87 5.87 0 0 0-.154 1.831l.419 5.783Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "74.595",
    cy: "77.519",
    rx: "13.546",
    ry: "13.18",
    transform: "rotate(-2.042 74.595 77.519)",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M73.953 61.569a15.963 15.963 0 1 0 1.137 31.906 15.963 15.963 0 0 0-1.137-31.906Zm.91 25.524a2.395 2.395 0 1 1-.171-4.786 2.395 2.395 0 0 1 .17 4.786Zm2.23-8.225a6.022 6.022 0 0 0-.625.373 1.996 1.996 0 0 1-3.9-.532c-.066-1.818 1.501-2.673 2.55-3.285 1.471-.835 2.077-1.304 2.037-2.437-.04-1.132-1.347-1.948-2.863-1.894-1.515.054-2.758 1.024-2.72 2.093a1.996 1.996 0 0 1-3.989.142 6.832 6.832 0 0 1 13.56-.483 6.545 6.545 0 0 1-4.05 6.023Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color14)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.507 31.893a1.925 1.925 0 0 1 1.838-.641l8.041 1.377c1.33.227 1.856 1.437 1.676 2.47-.058.424-.254.819-.558 1.124-.305.306-.7.505-1.13.569a2.095 2.095 0 0 1-.624-.02l-8.04-1.378a1.996 1.996 0 0 1-.964-.425 1.966 1.966 0 0 1-.608-.854 2.292 2.292 0 0 1 .369-2.222ZM31.071.093a1.782 1.782 0 0 1 1.973.594c.149.193.255.415.313.651l2.215 7.558a2.11 2.11 0 0 1-.196 1.637 2.137 2.137 0 0 1-1.316 1.008 2.188 2.188 0 0 1-.346.072c-.431.06-.87-.042-1.23-.287a1.724 1.724 0 0 1-.71-1.033l-2.213-7.555a2.109 2.109 0 0 1 .75-2.272c.226-.173.484-.3.76-.373ZM11.313 10.328a1.991 1.991 0 0 1 1.469.517l8.898 8.016a2.056 2.056 0 0 1 .18 2.86 2.001 2.001 0 0 1-2.13.597 2.011 2.011 0 0 1-.74-.424l-8.897-8.016a2.063 2.063 0 0 1-.177-2.875 1.982 1.982 0 0 1 1.397-.675Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color5)"
    }
  }));
};
DialogPageNotFound.defaultProps = {
  width: "160",
  height: "160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Dialog-PageNotFound"
};
var DotPageNotFound = function DotPageNotFound(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.292.573 6.228 2.533a2.367 2.367 0 0 0-2.19 2.531L6.8 43.231a2.367 2.367 0 0 0 2.531 2.19l27.065-1.96a2.367 2.367 0 0 0 2.19-2.531L35.824 2.763a2.367 2.367 0 0 0-2.532-2.19Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.228 2.533a2.365 2.365 0 0 0-1.592.781c.278.396.803.563 1.271.373a1.3 1.3 0 0 1 .397-.092l1.805-.131a1.065 1.065 0 0 0 .985-1.139l-2.866.208Zm6.155-.446a1.065 1.065 0 0 0 1.139.985l3.608-.261a1.065 1.065 0 0 0 .985-1.139l-5.732.415Zm9.021-.653a1.065 1.065 0 0 0 1.14.985l3.608-.261a1.065 1.065 0 0 0 .985-1.139l-5.733.415Zm9.022-.653a1.065 1.065 0 0 0 1.139.985l1.804-.13a1.3 1.3 0 0 1 .406.033c.491.121.986-.12 1.205-.552a2.375 2.375 0 0 0-.95-.481 2.365 2.365 0 0 0-.738-.063l-2.866.208Zm4.616.39a1.065 1.065 0 0 0-.372 1.272c.05.122.081.255.092.397L34.9 4.75a1.065 1.065 0 0 0 1.139.985l-.215-2.97a2.363 2.363 0 0 0-.782-1.593ZM36.3 9.335a1.065 1.065 0 0 0-.985 1.138l.277 3.817a1.065 1.065 0 0 0 1.139.985l-.43-5.94Zm.691 9.541a1.065 1.065 0 0 0-.985 1.139l.276 3.817a1.065 1.065 0 0 0 1.14.985l-.43-5.94Zm.69 9.542a1.065 1.065 0 0 0-.984 1.139l.276 3.816a1.065 1.065 0 0 0 1.139.985l-.43-5.94Zm.692 9.541a1.065 1.065 0 0 0-.985 1.14l.138 1.908c.01.142-.003.278-.034.406-.121.49.12.986.552 1.205a2.38 2.38 0 0 0 .482-.95c.058-.236.08-.484.062-.738l-.215-2.97Zm-.383 4.721a1.065 1.065 0 0 0-1.272-.373 1.3 1.3 0 0 1-.397.092l-1.804.131a1.065 1.065 0 0 0-.985 1.139l2.866-.208a2.368 2.368 0 0 0 1.592-.781Zm-7.747 1.227a1.065 1.065 0 0 0-1.14-.985l-3.608.261a1.065 1.065 0 0 0-.985 1.139l5.732-.415Zm-9.022.653a1.065 1.065 0 0 0-1.139-.985l-3.608.261a1.065 1.065 0 0 0-.985 1.139l5.732-.415Zm-9.022.653a1.065 1.065 0 0 0-1.138-.985l-1.805.13a1.3 1.3 0 0 1-.406-.033c-.49-.121-.986.12-1.205.552a2.378 2.378 0 0 0 .95.481c.235.058.484.08.738.063l2.866-.208Zm-4.616-.39c.396-.28.563-.804.373-1.272a1.3 1.3 0 0 1-.092-.397l-.139-1.909a1.065 1.065 0 0 0-1.138-.985l.215 2.97a2.365 2.365 0 0 0 .78 1.593Zm-1.257-8.164a1.065 1.065 0 0 0 .985-1.139l-.276-3.816a1.065 1.065 0 0 0-1.14-.985l.43 5.94Zm-.69-9.541a1.065 1.065 0 0 0 .984-1.14l-.276-3.816a1.065 1.065 0 0 0-1.139-.985l.43 5.94Zm-.692-9.542a1.065 1.065 0 0 0 .985-1.139l-.276-3.816a1.065 1.065 0 0 0-1.139-.985l.43 5.94Zm-.69-9.541a1.065 1.065 0 0 0 .985-1.14L5.1 4.988a1.3 1.3 0 0 1 .034-.406c.12-.49-.12-.986-.552-1.204a2.376 2.376 0 0 0-.482.95c-.058.234-.08.483-.062.737l.215 2.97Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "22.219",
    cy: "23.742",
    rx: "6.325",
    ry: "6.154",
    transform: "rotate(-2.042 22.22 23.742)",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.92 16.295a7.453 7.453 0 1 0 .53 14.897 7.453 7.453 0 0 0-.53-14.897Zm.424 11.917a1.118 1.118 0 1 1-.08-2.235 1.118 1.118 0 0 1 .08 2.235Zm1.042-3.84c-.1.052-.198.11-.292.174a.931.931 0 0 1-1.821-.248c-.03-.85.701-1.248 1.19-1.534.688-.39.97-.61.952-1.138-.02-.529-.63-.91-1.337-.885-.707.026-1.288.479-1.27.978a.932.932 0 0 1-1.862.066 3.19 3.19 0 0 1 6.33-.225 3.056 3.056 0 0 1-1.89 2.812Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color14)"
    }
  }));
};
DotPageNotFound.defaultProps = {
  width: "45",
  height: "46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Dot-PageNotFound"
};
var ScenePageNotFound = function ScenePageNotFound(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M305.547 0H14.453A14.44 14.44 0 0 0 0 14.44v171.107A14.454 14.454 0 0 0 14.453 200h291.094A14.456 14.456 0 0 0 320 185.547V14.44a14.45 14.45 0 0 0-4.234-10.215A14.441 14.441 0 0 0 305.547 0Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.88 100.001h135.93a3.118 3.118 0 0 1 2.037.717 3.137 3.137 0 0 1 1.088 1.87l16.531 85.732a3.142 3.142 0 0 1-1.746 3.541 3.109 3.109 0 0 1-1.379.284H27.972a3.193 3.193 0 0 1-2.009-.716 3.22 3.22 0 0 1-1.116-1.824L6.756 103.874a3.146 3.146 0 0 1 .608-2.711 3.119 3.119 0 0 1 2.516-1.162Zm13.436 22.891L33.691 179.9c.123.739.506 1.41 1.079 1.89s1.299.739 2.046.728h93.589a3.107 3.107 0 0 0 2.478-1.137 3.15 3.15 0 0 0 .647-2.657l-3.75-19.771h14.655a3.209 3.209 0 0 0 2.458-1.187 3.231 3.231 0 0 0 .667-2.654l-8.031-42.787a3.248 3.248 0 0 0-1.096-1.874 3.225 3.225 0 0 0-2.028-.76H96.407a3.203 3.203 0 0 0-2.451 1.182 3.228 3.228 0 0 0-.674 2.643l1.093 5.833-67.856-.235a3.102 3.102 0 0 0-1.39.256 3.135 3.135 0 0 0-1.813 3.522Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M206.667 192.145H64.705l3.969 5.66A5.156 5.156 0 0 0 72.892 200H28.238a3.12 3.12 0 0 1-2.21-.918 3.144 3.144 0 0 1-.915-2.218v-1.427c0-.831.33-1.629.915-2.217a3.12 3.12 0 0 1 2.21-.918h178.429v-.157Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m68.673 197.805-3.968-5.66h141.962v5.08c0 .736-.292 1.442-.81 1.962a2.76 2.76 0 0 1-1.956.813H72.892a5.148 5.148 0 0 1-4.219-2.195ZM119.624 119.443l-25.327-.094-1.093-5.833a3.237 3.237 0 0 1 1.768-3.507 3.218 3.218 0 0 1 1.356-.318h39.998c.744.012 1.46.28 2.029.76s.956 1.141 1.096 1.874l8.031 42.787a3.245 3.245 0 0 1-1.764 3.522c-.425.205-.89.314-1.361.32h-14.655l-7.016-36.908a3.138 3.138 0 0 0-1.059-1.86 3.119 3.119 0 0 0-2.003-.743Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M96.703 142.036a1.292 1.292 0 0 1-.301-1.454c.07-.162.172-.308.301-.428a1.296 1.296 0 0 1 1.875 0l3.125 3.136 3.125-3.136a1.324 1.324 0 0 1 1.821.054 1.332 1.332 0 0 1 .054 1.828l-3.125 3.135 3.125 3.136a1.344 1.344 0 0 1 .445.957 1.338 1.338 0 0 1-.837 1.278 1.332 1.332 0 0 1-1.052-.031 1.339 1.339 0 0 1-.431-.322l-3.125-3.136-3.125 3.136a1.296 1.296 0 0 1-1.875 0 1.292 1.292 0 0 1-.301-1.454c.07-.162.172-.307.301-.428l3.125-3.136-3.125-3.135Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m26.472 119.114 67.856.235 25.327.094a3.12 3.12 0 0 1 2.042.722 3.134 3.134 0 0 1 1.083 1.88l7.016 36.908 3.749 19.771a3.135 3.135 0 0 1-3.124 3.794H36.925a3.121 3.121 0 0 1-2.046-.728 3.141 3.141 0 0 1-1.079-1.89l-10.452-57.008a3.146 3.146 0 0 1 .653-2.646 3.128 3.128 0 0 1 2.471-1.132Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M282.156 137.042c1.249 10.641 1.762 22.894-6.447 23.034-10.29.173-10.586-9.951-11.836-20.625-1.249-10.675-.757-19.621 6.911-20.529 7.194-.864 10.115 7.432 11.372 18.12Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M288.038 126.894c3.453-4.205 4.359-9.2 2.023-11.159-2.335-1.959-7.027-.139-10.481 4.065-3.453 4.205-4.359 9.2-2.023 11.159 2.335 1.959 7.028.139 10.481-4.065ZM298.421 147.707c.056 6.118-2.759 11.077-6.284 11.142-8.61.158-6.916-4.838-6.484-11.027.432-6.189 2.76-11.03 6.284-11.142 6.462-.211 6.429 4.875 6.484 11.027Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m303.302 165.673-47.358.428a1.02 1.02 0 0 0-1.006 1.034l.293 32.308a1.02 1.02 0 0 0 1.023 1.016l47.358-.428a1.02 1.02 0 0 0 1.006-1.034l-.292-32.308a1.02 1.02 0 0 0-1.024-1.016Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m303.217 159.921-47.286.427a1.02 1.02 0 0 0-1.005 1.035l.105 11.597a1.02 1.02 0 0 0 1.024 1.016l47.285-.428a1.02 1.02 0 0 0 1.006-1.034l-.105-11.597a1.02 1.02 0 0 0-1.024-1.016Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m306.042 155.441-52.635.476a1.02 1.02 0 0 0-1.005 1.035l.115 12.708a1.018 1.018 0 0 0 1.024 1.016l52.635-.475a1.02 1.02 0 0 0 1.005-1.035l-.115-12.709a1.02 1.02 0 0 0-1.024-1.016Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m254.656 63.107-69.618-23.936c-2.951-1.015-6.164.564-7.175 3.526l-34.699 101.661c-1.011 2.963.562 6.187 3.513 7.202l69.618 23.936c2.951 1.015 6.164-.564 7.175-3.526l34.699-101.661c1.011-2.963-.562-6.187-3.513-7.202Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M212.902 64.85a12.472 12.472 0 0 0-7.238-.62 12.5 12.5 0 0 0-6.362 3.52 12.6 12.6 0 0 0-2.538 13.72 12.548 12.548 0 0 0 4.68 5.576 12.48 12.48 0 0 0 13.902-.177 12.55 12.55 0 0 0 4.537-5.693l-11.628-4.654 4.647-11.671Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m216.622 63.128-4.637 11.661 11.618 4.654a12.583 12.583 0 0 0-2.887-13.647 12.497 12.497 0 0 0-4.094-2.668Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color20)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m226.264 104.838-48.513-16.68a3.077 3.077 0 0 0-3.912 1.923 3.094 3.094 0 0 0 1.916 3.927l48.512 16.68a3.078 3.078 0 0 0 3.912-1.923 3.094 3.094 0 0 0-1.915-3.927ZM222.069 114.731l-48.513-16.68a3.077 3.077 0 0 0-3.912 1.923 3.094 3.094 0 0 0 1.916 3.927l48.512 16.679a3.076 3.076 0 0 0 3.912-1.923 3.093 3.093 0 0 0-1.915-3.926ZM195.424 116.654l-25.844-8.886a3.078 3.078 0 0 0-3.913 1.922 3.095 3.095 0 0 0 1.916 3.927l25.844 8.886a3.078 3.078 0 0 0 3.913-1.923 3.094 3.094 0 0 0-1.916-3.926Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m191.042 37.833-77.85 5.636a6.809 6.809 0 0 0-6.299 7.282l7.948 109.784a6.807 6.807 0 0 0 7.282 6.299l77.85-5.635a6.81 6.81 0 0 0 6.299-7.283l-7.947-109.784a6.809 6.809 0 0 0-7.283-6.299Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.192 43.469a6.802 6.802 0 0 0-3.255 1.104 6.847 6.847 0 0 0-1.045.85 2.668 2.668 0 0 0 3.23.999c.389-.159.812-.26 1.263-.293l5.19-.376a2.667 2.667 0 0 0 2.467-2.852l-7.85.568Zm18.101-1.31a2.666 2.666 0 0 0 2.852 2.467l10.38-.752a2.667 2.667 0 0 0 2.467-2.852l-15.699 1.137Zm25.95-1.879a2.666 2.666 0 0 0 2.852 2.467l10.38-.751a2.667 2.667 0 0 0 2.467-2.852l-15.699 1.136Zm25.95-1.879a2.666 2.666 0 0 0 2.852 2.468l5.19-.376c.45-.033.884.007 1.292.108a2.668 2.668 0 0 0 3.052-1.454 6.827 6.827 0 0 0-2.413-1.135 6.81 6.81 0 0 0-2.124-.179l-7.849.569Zm13.178 1.431a2.667 2.667 0 0 0-.999 3.23c.158.39.26.812.293 1.263l.397 5.489a2.667 2.667 0 0 0 2.852 2.467l-.589-8.149a6.817 6.817 0 0 0-1.105-3.255 6.762 6.762 0 0 0-.849-1.045Zm3.351 23.597a2.668 2.668 0 0 0-2.468 2.853l.795 10.978a2.666 2.666 0 0 0 2.852 2.467l-1.179-16.298Zm1.986 27.446a2.667 2.667 0 0 0-2.467 2.853l.795 10.978a2.666 2.666 0 0 0 2.852 2.467l-1.18-16.298Zm1.987 27.446a2.668 2.668 0 0 0-2.467 2.853l.795 10.978a2.666 2.666 0 0 0 2.852 2.467l-1.18-16.298Zm1.987 27.446a2.668 2.668 0 0 0-2.467 2.853l.397 5.489c.033.45-.007.884-.108 1.292a2.668 2.668 0 0 0 1.454 3.052 6.813 6.813 0 0 0 1.135-2.414c.167-.676.232-1.39.179-2.123l-.59-8.149Zm-1.409 13.478a2.667 2.667 0 0 0-3.229-.999c-.39.158-.813.26-1.264.293l-5.19.376a2.667 2.667 0 0 0-2.467 2.852l7.85-.568a6.84 6.84 0 0 0 2.075-.483 6.736 6.736 0 0 0 1.18-.622 6.732 6.732 0 0 0 1.045-.849Zm-22.4 3.264a2.667 2.667 0 0 0-2.853-2.467l-10.38.751a2.666 2.666 0 0 0-2.467 2.852l15.7-1.136Zm-25.95 1.878a2.668 2.668 0 0 0-2.853-2.467l-10.38.752a2.666 2.666 0 0 0-2.467 2.852l15.7-1.137Zm-25.951 1.879a2.666 2.666 0 0 0-2.852-2.467l-5.19.375a4.113 4.113 0 0 1-1.292-.108 2.668 2.668 0 0 0-3.052 1.454 6.813 6.813 0 0 0 2.414 1.135c.676.167 1.39.232 2.123.179l7.849-.568Zm-13.178-1.431a2.666 2.666 0 0 0 .999-3.229 4.165 4.165 0 0 1-.293-1.263l-.397-5.49a2.667 2.667 0 0 0-2.852-2.467l.59 8.149a6.809 6.809 0 0 0 1.104 3.255c.249.377.533.727.849 1.045Zm-3.35-23.597a2.666 2.666 0 0 0 2.467-2.852l-.795-10.979a2.666 2.666 0 0 0-2.852-2.467l1.18 16.298Zm-1.987-27.446a2.666 2.666 0 0 0 2.467-2.852l-.795-10.979a2.666 2.666 0 0 0-2.852-2.467l1.18 16.298Zm-1.987-27.446a2.667 2.667 0 0 0 2.467-2.852l-.795-10.979a2.666 2.666 0 0 0-2.852-2.467l1.18 16.298ZM107.483 58.9a2.666 2.666 0 0 0 2.467-2.852l-.397-5.49c-.033-.45.007-.883.108-1.292a2.667 2.667 0 0 0-1.454-3.052c-.266.361-.498.748-.69 1.157a6.798 6.798 0 0 0-.624 3.38l.59 8.149Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "158.072",
    cy: "103.317",
    rx: "15.841",
    ry: "15.413",
    transform: "rotate(-2.042 158.072 103.317)",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M157.322 84.665a18.663 18.663 0 0 0-16.825 12.131 18.667 18.667 0 1 0 16.825-12.13Zm1.064 29.848a2.799 2.799 0 0 1-.744-5.523 2.801 2.801 0 0 1 2.693 4.633 2.795 2.795 0 0 1-1.949.89Zm2.608-9.619a7.213 7.213 0 0 0-.732.437 2.333 2.333 0 0 1-4.561-.622c-.075-2.126 1.757-3.126 2.983-3.842 1.721-.977 2.43-1.525 2.382-2.85-.047-1.324-1.575-2.278-3.347-2.215-1.773.063-3.226 1.199-3.182 2.449a2.333 2.333 0 1 1-4.664.166 7.99 7.99 0 0 1 15.857-.566 7.652 7.652 0 0 1-4.736 7.043Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color14)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M72.587 48.971a2.233 2.233 0 0 1 2.13-.743l9.323 1.596c1.542.264 2.151 1.667 1.942 2.863-.067.493-.294.95-.647 1.305a2.328 2.328 0 0 1-1.309.658 2.43 2.43 0 0 1-.723-.023L73.98 53.03a2.315 2.315 0 0 1-1.117-.494 2.28 2.28 0 0 1-.704-.99 2.657 2.657 0 0 1 .427-2.576ZM108.019 12.108a2.064 2.064 0 0 1 2.286.688c.173.224.296.481.363.755l2.569 8.762a2.452 2.452 0 0 1-.872 2.634c-.262.2-.562.347-.882.432a2.516 2.516 0 0 1-.401.083c-.5.07-1.008-.049-1.424-.332a1.999 1.999 0 0 1-.825-1.197l-2.565-8.759a2.438 2.438 0 0 1 .225-1.897 2.474 2.474 0 0 1 1.526-1.169ZM85.114 23.973a2.307 2.307 0 0 1 1.703.6l10.315 9.291a2.384 2.384 0 0 1 .209 3.316 2.32 2.32 0 0 1-2.468.692 2.331 2.331 0 0 1-.858-.492L83.7 28.088a2.39 2.39 0 0 1-.205-3.333 2.297 2.297 0 0 1 1.619-.783Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color5)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.333 73.333a4.667 4.667 0 1 1 0-9.333 4.667 4.667 0 0 1 0 9.333Zm0-1.244a3.422 3.422 0 1 1 0-6.845 3.422 3.422 0 0 1 0 6.845ZM279.333 62.667a4.666 4.666 0 1 1 0-9.333 4.666 4.666 0 0 1 0 9.333Zm0-1.245a3.422 3.422 0 1 1 0-6.844 3.422 3.422 0 0 1 0 6.844ZM171.333 21.333a4.666 4.666 0 1 1 0-9.332 4.666 4.666 0 0 1 0 9.332Zm0-1.244a3.422 3.422 0 1 1 0-6.844 3.422 3.422 0 0 1 0 6.844Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.02 21.222c-.73-1.056-4.377.214-8.605 2.847-3.056-3.928-6.056-6.347-7.11-5.616-1.055.731.182 4.401 2.794 8.667-3.913 3.115-6.333 6.14-5.589 7.188.744 1.049 4.378-.211 8.604-2.848 3.068 3.92 6.057 6.348 7.109 5.618 1.052-.729-.18-4.403-2.792-8.669 3.913-3.114 6.33-6.137 5.588-7.187ZM254.829 30.223c.293-1.249-3.099-3.098-7.89-4.459.856-4.903.632-8.75-.618-9.04-1.25-.29-3.137 3.092-4.542 7.893-4.936-.805-8.802-.565-9.078.69-.277 1.256 3.098 3.1 7.89 4.46-.842 4.906-.632 8.75.615 9.039 1.247.29 3.14-3.092 4.545-7.892 4.936.805 8.799.564 9.078-.69Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }));
};
ScenePageNotFound.defaultProps = {
  width: "320",
  height: "201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Scene-PageNotFound"
};
var SpotPageNotFound = function SpotPageNotFound(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_2331_5786",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "128",
    height: "128"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "64",
    cy: "64",
    r: "64",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_2331_5786)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M155.132-1.742H-34.969a9.43 9.43 0 0 0-9.44 9.43v111.744a9.438 9.438 0 0 0 9.44 9.439h190.101a9.44 9.44 0 0 0 9.439-9.439V7.689a9.438 9.438 0 0 0-2.765-6.672 9.424 9.424 0 0 0-6.674-2.759Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M-37.956 63.565h88.77c.486-.007.957.159 1.33.468.375.31.627.743.712 1.222l10.795 55.988a2.053 2.053 0 0 1-1.14 2.312c-.283.13-.59.194-.9.186h-87.752a2.086 2.086 0 0 1-1.312-.468 2.1 2.1 0 0 1-.728-1.191l-11.816-55.988a2.054 2.054 0 0 1 1.13-2.342c.286-.132.597-.196.91-.187Zm8.775 14.95 6.775 37.229a2.047 2.047 0 0 0 2.04 1.71h61.12a2.028 2.028 0 0 0 1.619-.743 2.045 2.045 0 0 0 .422-1.735l-2.45-12.911h9.572a2.104 2.104 0 0 0 2.04-2.509l-5.244-27.943a2.12 2.12 0 0 0-2.04-1.72H18.55a2.096 2.096 0 0 0-1.6.772 2.113 2.113 0 0 0-.44 1.726l.714 3.81-44.315-.154a2.034 2.034 0 0 0-1.649.719 2.05 2.05 0 0 0-.442 1.748Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M90.558 123.741h-92.71l2.592 3.696a3.367 3.367 0 0 0 2.755 1.434h-29.162c-.542 0-1.06-.216-1.443-.6a2.052 2.052 0 0 1-.598-1.448v-.932c0-.543.215-1.064.598-1.448.383-.384.901-.6 1.443-.6H90.558v-.102Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m.44 127.437-2.592-3.696h92.71v3.317c0 .481-.19.942-.53 1.282-.338.34-.797.531-1.276.531H3.195a3.367 3.367 0 0 1-2.755-1.434ZM33.714 76.262l-16.54-.062-.715-3.809a2.117 2.117 0 0 1 .44-1.726 2.105 2.105 0 0 1 1.601-.772h26.121c.485.008.953.183 1.325.496.372.314.625.746.716 1.224l5.245 27.943a2.115 2.115 0 0 1-1.153 2.3c-.277.134-.58.205-.888.209h-9.571l-4.581-24.103a2.05 2.05 0 0 0-.693-1.215 2.036 2.036 0 0 0-1.307-.485Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.745 91.016a.838.838 0 0 1-.197-.95.839.839 0 0 1 .197-.279.847.847 0 0 1 1.224 0l2.041 2.048 2.04-2.047a.866.866 0 0 1 1.444.624.873.873 0 0 1-.219.604l-2.04 2.048 2.04 2.048a.871.871 0 0 1-.601 1.52.865.865 0 0 1-.623-.291l-2.04-2.048-2.042 2.048a.845.845 0 0 1-1.224 0 .837.837 0 0 1-.197-.95.837.837 0 0 1 .197-.279l2.04-2.048-2.04-2.048Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m-27.12 76.047 44.314.154 16.54.06a2.05 2.05 0 0 1 2.04 1.7l4.582 24.104 2.449 12.911a2.054 2.054 0 0 1-1.147 2.293c-.28.129-.586.192-.894.185h-61.058a2.046 2.046 0 0 1-2.04-1.71l-6.827-37.23a2.054 2.054 0 0 1 1.15-2.282c.279-.129.584-.192.89-.185Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M139.857 87.755c.816 6.95 1.15 14.951-4.21 15.043-6.721.113-6.914-6.499-7.73-13.47-.816-6.97-.494-12.813 4.513-13.406 4.698-.564 6.606 4.853 7.427 11.833Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m153.666 106.453-30.927.279a.667.667 0 0 0-.657.676l.191 21.099c.003.37.303.667.669.664l30.927-.28a.667.667 0 0 0 .657-.676l-.191-21.099a.665.665 0 0 0-.669-.663Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m153.611 102.697-30.88.279a.667.667 0 0 0-.657.675l.069 7.574c.003.37.302.667.668.664l30.88-.28a.666.666 0 0 0 .657-.675l-.068-7.574a.666.666 0 0 0-.669-.663Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m155.456 99.771-34.374.311a.665.665 0 0 0-.656.675l.075 8.3c.003.37.302.667.668.664l34.374-.311a.667.667 0 0 0 .657-.676l-.075-8.299a.666.666 0 0 0-.669-.664Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M121.898 39.471 76.433 23.84a3.686 3.686 0 0 0-4.686 2.303l-22.66 66.39a3.706 3.706 0 0 0 2.294 4.703l45.465 15.632a3.685 3.685 0 0 0 4.685-2.303l22.661-66.39a3.707 3.707 0 0 0-2.294-4.703Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M94.63 40.61a8.144 8.144 0 0 0-8.882 1.893 8.23 8.23 0 0 0-1.657 8.96 8.193 8.193 0 0 0 3.056 3.642 8.15 8.15 0 0 0 9.079-.115 8.196 8.196 0 0 0 2.963-3.718l-7.594-3.04 3.035-7.622Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M97.06 39.485 94.03 47.1l7.588 3.04a8.218 8.218 0 0 0-1.886-8.913 8.16 8.16 0 0 0-2.674-1.742Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color20)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M103.356 66.724 71.674 55.831a2.01 2.01 0 0 0-2.555 1.256 2.02 2.02 0 0 0 1.251 2.564l31.682 10.893a2.01 2.01 0 0 0 2.555-1.255 2.02 2.02 0 0 0-1.251-2.565ZM100.616 73.185 68.935 62.292a2.01 2.01 0 0 0-2.555 1.256 2.02 2.02 0 0 0 1.25 2.564l31.682 10.893a2.01 2.01 0 0 0 2.555-1.256 2.02 2.02 0 0 0-1.251-2.564ZM83.216 74.44l-16.878-5.803a2.01 2.01 0 0 0-2.555 1.256 2.02 2.02 0 0 0 1.25 2.564l16.879 5.803a2.01 2.01 0 0 0 2.555-1.255 2.02 2.02 0 0 0-1.251-2.565Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m80.354 22.966-50.84 3.68a4.446 4.446 0 0 0-4.114 4.756l5.19 71.696a4.445 4.445 0 0 0 4.755 4.113l50.841-3.68a4.446 4.446 0 0 0 4.114-4.756L85.11 27.08a4.446 4.446 0 0 0-4.756-4.113Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.513 26.646a4.443 4.443 0 0 0-2.99 1.468 2 2 0 0 0 2.389.7c.23-.093.479-.154.746-.173l3.39-.245a2 2 0 0 0 1.85-2.14l-5.385.39Zm11.563-.837a2 2 0 0 0 2.14 1.85l6.778-.49a2 2 0 0 0 1.85-2.14l-10.768.78Zm16.947-1.227a2 2 0 0 0 2.14 1.85l6.778-.49a2 2 0 0 0 1.85-2.14l-10.768.78Zm16.947-1.226a2 2 0 0 0 2.14 1.85l3.389-.245c.266-.02.522.004.763.063a2 2 0 0 0 2.263-1.037 4.463 4.463 0 0 0-1.784-.904 4.445 4.445 0 0 0-1.387-.117l-5.384.39Zm8.672.733a2 2 0 0 0-.7 2.389c.094.23.154.48.173.746l.26 3.585a2 2 0 0 0 2.139 1.85l-.404-5.58a4.443 4.443 0 0 0-1.468-2.99Zm2.362 15.335a2 2 0 0 0-1.85 2.139l.518 7.17a2 2 0 0 0 2.14 1.85l-.808-11.16ZM87.3 57.348a2 2 0 0 0-1.85 2.139l.519 7.17a2 2 0 0 0 2.139 1.85l-.808-11.16ZM88.6 75.272a2 2 0 0 0-1.85 2.139l.518 7.17a2 2 0 0 0 2.14 1.85l-.808-11.16Zm1.297 17.924a2 2 0 0 0-1.85 2.139l.26 3.585c.019.266-.005.522-.064.763a2 2 0 0 0 1.036 2.263 4.433 4.433 0 0 0 1.022-3.17l-.404-5.58Zm-.72 8.867a2.001 2.001 0 0 0-2.388-.7c-.23.093-.48.154-.746.173l-3.39.245a2 2 0 0 0-1.85 2.14l5.384-.39a4.45 4.45 0 0 0 2.99-1.468Zm-14.552 2.305a2 2 0 0 0-2.14-1.85l-6.778.49a2 2 0 0 0-1.85 2.139l10.768-.779Zm-16.947 1.227a2 2 0 0 0-2.14-1.851l-6.778.491a2 2 0 0 0-1.85 2.139l10.768-.779Zm-16.947 1.227a2 2 0 0 0-2.14-1.851l-3.389.246a2.462 2.462 0 0 1-.763-.064 2 2 0 0 0-2.263 1.037 4.47 4.47 0 0 0 1.784.905 4.43 4.43 0 0 0 1.386.116l5.385-.389Zm-8.673-.734a2 2 0 0 0 .7-2.388 2.448 2.448 0 0 1-.172-.747l-.26-3.585a2 2 0 0 0-2.14-1.85l.405 5.58a4.445 4.445 0 0 0 1.467 2.99Zm-2.36-15.335a2 2 0 0 0 1.85-2.139l-.52-7.17a2 2 0 0 0-2.139-1.85l.808 11.16ZM28.398 72.83a2 2 0 0 0 1.85-2.139l-.519-7.17a2 2 0 0 0-2.14-1.85l.809 11.16ZM27.1 54.905a2 2 0 0 0 1.85-2.139l-.519-7.17a2 2 0 0 0-2.139-1.85l.808 11.16Zm-1.297-17.924a2 2 0 0 0 1.85-2.139l-.26-3.584c-.019-.267.005-.523.064-.764a2 2 0 0 0-1.037-2.263 4.463 4.463 0 0 0-.905 1.784 4.445 4.445 0 0 0-.116 1.387l.404 5.58Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "59.554",
    cy: "66.487",
    rx: "11.881",
    ry: "11.56",
    transform: "rotate(-2.042 59.554 66.487)",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.991 52.499a14 14 0 1 0 .998 27.983 14 14 0 0 0-.998-27.983Zm.798 22.386a2.1 2.1 0 1 1-.15-4.197 2.1 2.1 0 0 1 .15 4.197Zm1.956-7.215c-.189.099-.372.208-.548.328a1.75 1.75 0 0 1-3.421-.467c-.057-1.595 1.317-2.344 2.237-2.881 1.29-.733 1.822-1.144 1.787-2.137-.036-.993-1.182-1.709-2.511-1.662-1.33.048-2.42.9-2.386 1.837a1.75 1.75 0 1 1-3.498.124 5.992 5.992 0 0 1 11.892-.424 5.74 5.74 0 0 1-3.551 5.282Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color14)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.435 49.633a3.048 3.048 0 1 1 0-6.095 3.048 3.048 0 0 1 0 6.095Zm0-.813a2.235 2.235 0 1 1 0-4.47 2.235 2.235 0 0 1 0 4.47ZM67.483 12.19a3.048 3.048 0 1 1 0-6.095 3.048 3.048 0 0 1 0 6.096Zm0-.812a2.235 2.235 0 1 1 0-4.47 2.235 2.235 0 0 1 0 4.47Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M122.011 17.996c.191-.816-2.024-2.023-5.153-2.912.559-3.202.413-5.714-.403-5.904-.817-.189-2.049 2.02-2.967 5.155-3.223-.526-5.748-.37-5.928.45-.181.82 2.023 2.026 5.152 2.913-.55 3.204-.412 5.714.402 5.903.814.189 2.051-2.019 2.968-5.154 3.223.526 5.746.369 5.929-.45Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  })));
};
SpotPageNotFound.defaultProps = {
  width: "128",
  height: "128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Spot-PageNotFound"
};
const illustrationImports = {
  DialogPageNotFound,
  DotPageNotFound,
  ScenePageNotFound,
  SpotPageNotFound
};
/** **Illustration**s are design recommendations for empty states. They include an illustration
 * paired with a message that, together, communicate what the user would see if they had data,
 * while providing constructive guidance about next steps.
 * They serve to add clarity and to humanize the experience users have with SAP products.
 *
 * Use with
 * [**IllustrationMessage**](./?path=/docs/components-alerts-messaging-illustratedmessage--docs)
 * to provide a complete message.
 *
 * To request additional illustrations, contact #ask-core-ui.
 *
 * For instructions on which illustration to use for a given scenarios, contact #ask-ux-design-systems. */
const PageNotFound = props => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _a = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(PageNotFound, props)) : props,
    {
      size = 'md',
      useResponsiveSizing,
      containerRef
    } = _a,
    otherProps = __rest(_a, ["size", "useResponsiveSizing", "containerRef"]);
  let variant = 'Dialog';
  const windowSize = (0, _useWindowSize.default)();
  const {
    width: containerWidth,
    height: containerHeight
  } = (0, _useResizeObserver.default)({
    targetRef: containerRef
  });
  if (size === 'lg') {
    variant = 'Scene';
  } else if (size === 'sm') {
    variant = 'Spot';
  } else if (size === 'xs') {
    variant = 'Dot';
  }
  const width = containerWidth || windowSize.width;
  const height = containerHeight || windowSize.height;
  if (useResponsiveSizing) {
    if (width <= 260 || height <= 207) {
      variant = 'Dot';
    } else if (width <= 360 || height <= 284) {
      variant = 'Spot';
    } else if (width <= 681 || height <= 415) {
      variant = 'Dialog';
    } else {
      variant = 'Scene';
    }
  }
  const importName = `${variant}PageNotFound`;
  return /*#__PURE__*/_react.default.createElement(_Illustration.default, Object.assign({}, otherProps, {
    variant: variant,
    screenReaderOnly: useResponsiveSizing && (width <= 160 || height <= 61),
    Component: illustrationImports[importName]
  }));
};
exports.PageNotFound = PageNotFound;
PageNotFound.displayName = 'PageNotFound';
var _default = exports.default = PageNotFound;